import type { MePermissions, UserRole } from "@/app/userRole";
import { apiClient } from "@/http";
import { apiRoutes } from "./apiRoutes";

export type CurrentMeUser = {
  uuid: string;
  display_name: string;
  email: string;
  // 사용자가 고른 training 종료 알림 수신 이메일. 로그인 `email` 과 다른 값이다.
  // 로그인 이메일은 GitHub noreply 주소일 수 있다. 그러면 Slack 이 사용자를 찾지 못한다.
  // null 이면 아직 고르지 않은 것이다. 알림 토글은 이 값을 상류 recipient 행의 식별 키로 쓴다.
  notification_email: string | null;
};

export type CurrentMeMember = {
  uuid: string;
};

// training 그룹 참조 1개(group_uuid + 표시 이름). /v1/me 의 연결 목록과
// /v1/training/me/groups 의 전체 목록은 shape 가 같다. 그래서 두 표면이 이 타입을 공유한다.
export type TrainingGroupRef = {
  group_uuid: string;
  name: string;
};

export type CurrentMeResp = {
  user: CurrentMeUser;
  member: CurrentMeMember;
  // member 의 단일 권한 등급(권위값).
  tier: UserRole;
  // 서버가 계산하고 /v1/me가 항상 포함하는 권한 모음.
  permissions: MePermissions;
  // training-infra Group 이 연결된 내 소속 팀. group Dataset 피커와 제출 귀속이 이 값을 쓴다.
  // /v1/me 가 항상 포함한다(없으면 빈 배열). 연결되지 않은 팀도 필요하면 listMyTrainingGroups 를
  // 쓴다.
  linked_training_groups: TrainingGroupRef[];
};

export async function getCurrentMe(): Promise<CurrentMeResp> {
  const response = await apiClient.get<CurrentMeResp>(apiRoutes.me.current);
  return response.data;
}

// `PATCH /v1/me`. 서버는 보낸 키만 적용한다. 이 앱은 `notification_email` 만 보낸다.
// 서버가 값을 trim·lowercase 해 저장한다. 그래서 입력값이 아니라 응답의 값을 정본으로 쓴다.
export async function updateCurrentMeNotificationEmail(
  notificationEmail: string,
): Promise<CurrentMeResp> {
  const response = await apiClient.patch<CurrentMeResp>(apiRoutes.me.current, {
    notification_email: notificationEmail,
  });
  return response.data;
}
